import React, { FC, ReactNode } from 'react';
import { TimeService }          from '../../../services';
import { FinePrintMessage }     from '../util/messaging/FinePrintMessage';

export interface AuditMemoStatementProps {
	preamble?: string | ReactNode,
	actionDesc?: string
	actionVerb?: string,
	auditSubject?: string,
	auditAdditionalInfo?: string | ReactNode,
	userLabel?: string,
	includeTimestampInMessage?: boolean,
	timestampUtc: string,
	timestampFormat?: string,
}

const auditMemoStatementPropsDefaultProps: AuditMemoStatementProps = {
	preamble:                  null,
	actionDesc:                'made the decision to',
	actionVerb:                'update',
	auditSubject:              'this item',
	includeTimestampInMessage: true,
	timestampUtc:              null,
	timestampFormat:           TimeService.displayDateFormat,
}

const AuditMemoStatement: FC<AuditMemoStatementProps> = ( props ) => {
	
	return (
		<FinePrintMessage fadeIn={ false }>
			{ props.preamble }
			{ props.userLabel && <strong>{ props.userLabel }</strong> }
			{ props.actionDesc && <> { props.actionDesc }</> }
			{ props.actionVerb && <strong>{ <> { props.actionVerb }</> }</strong> }
			{ props.auditSubject ? ` ${ props.auditSubject }` : null }{ !props.includeTimestampInMessage ? '.' : null }
			{ props.includeTimestampInMessage && <> on <strong>{ TimeService.ISOtoFormat( props.timestampUtc, props.timestampFormat, true ) }</strong>.</> }
			{ props.auditAdditionalInfo && ` ${ props.auditAdditionalInfo }` }
		</FinePrintMessage>
	);
}

AuditMemoStatement.defaultProps = auditMemoStatementPropsDefaultProps;

export { AuditMemoStatement }
